<div id="inactive-tenants" class="space-y-2">
  <div class="flex flex-col">
    <div *ngIf="loading" class="absolute inset-x-0 top-0">
      <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
    </div>
    <div class="flex flex-row items-center place-content-between">
      <span class="text-2xl font-bold">Clientes sem acesso à plataforma</span>
      <div class="flex place-content-end space-x-2 justify-center items-center">
        <button (click)="exportSpreadsheet()" color="accent" mat-stroked-button>
          <mat-icon>import_export</mat-icon>
          Exportar
        </button>
        <mat-form-field class="w-72 fuse-mat-no-subscript">
          <mat-select (selectionChange)="selectPeriod()" [(value)]="selectedPeriod" placeholder="Filtrar">
            <mat-option [value]="1">Até uma semana</mat-option>
            <mat-option [value]="2">Uma a duas semanas</mat-option>
            <mat-option [value]="3">Duas semanas a 1 mês</mat-option>
            <mat-option [value]="4">1 mês a 6 meses</mat-option>
            <mat-option [value]="5">Há mais de 6 meses</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="content-card">
      <div class="container">
        <div class="content" fxFlex fxLayout="column" fusePerfectScrollbar>
          <table 
              mat-table 
              matSort
              (matSortChange)="onSortChanged($event)" 
              matSortActive="lastAccess"
              matSortDisableClear
              matSortDirection="asc"
              [dataSource]="dataSource"
            >
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Id</th>
              <td mat-cell *matCellDef="let row">{{ row.id }}</td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Nome</th>
              <td mat-cell *matCellDef="let row">{{ row.name }}</td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>E-mail</th>
              <td mat-cell *matCellDef="let row">{{ row.email }}</td>
            </ng-container>
            <ng-container matColumnDef="phoneNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Telefone</th>
              <td mat-cell *matCellDef="let row">{{ row.phoneNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="lastAccess">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Último Acesso</th>
              <td mat-cell *matCellDef="let row">{{ row.lastAccess.toLocaleDateString() }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        <mat-paginator 
          [length]="totalItems" 
          [pageSize]="pageSize" 
          hidePageSize="true" 
          showFirstLastButtons="true"
          (page)="onPageChanged($event)">
      </mat-paginator>
      </div>
    </div>
  </div>
</div>